import { getDocumentos } from '../../Dashboard/DeclarationSummary/DocumentosModal';
import { getDocumentosTipos } from '../../Dashboard/DeclarationSummary/DocumentosModal';

// Simple text display component
const TextDisplay = ({ value, className = "" }) => {
  const displayValue = value === null || value === undefined || value === '' ? 'null' : value;
  return (
    <p className={`${className} py-1`}>{displayValue}</p>
  );
};

export const DocumentsTable = ({
  declarationIndex,
  itemIndex,
  isSpanish,
  item,
  editableData,
  setEditableData,
  setIsDirty,
}) => {
  const documentos = getDocumentos();

  return (
    <div>
      <div className="form-group flex-1 mt-6 !mb-0 flex justify-between flex-row items-center">
        <label htmlFor="companyName" className="!mb-0 !text-sm !opacity-100 text-xl font-semibold uppercase">
          {!isSpanish ? "Documents" : "Documentos"} (
          {item.documentos?.length || 0})
        </label>
        {/* <button
          className="py-1 text-xs flex items-center gap-1"
          onClick={() => {
            const updatedData = [...editableData];
            if (!updatedData[declarationIndex].partidas[itemIndex].documentos)
              updatedData[declarationIndex].partidas[itemIndex].documentos = [];
            updatedData[declarationIndex].partidas[itemIndex].documentos.push({
              codigo_documento: "",
              tipo: "",
              numero: "",
              fecha: "",
            });
            setEditableData(updatedData);
            setIsDirty(true);
          }}
        >
          <Plus className={`size-4`} />
          {isSpanish ? "Agregar Documento" : "Add Document"}
        </button> */}
      </div>
      <div className="overflow-auto">
        <table className="min-w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="py-2 px-4 pt-2 pl-0">
                <p className="w-max">
                  {!isSpanish ? "Document Code" : "Código de Documento"}
                </p>
              </th>
              <th className="py-2 px-4 pt-2">
                <p className="w-max">{!isSpanish ? "Type" : "Tipo"}</p>
              </th>
              <th className="py-2 px-4 pt-2">
                <p className="w-max">{!isSpanish ? "Number" : "Número"}</p>
              </th>
              <th className="py-2 px-4 pt-2">
                <p className="w-max">{!isSpanish ? "Date" : "Fecha"}</p>
              </th>
              {/* <th className="py-2 px-4 pt-2"></th> */}
            </tr>
          </thead>
          <tbody>
            {item.documentos?.map((item, docIndex) => {
              const selectedDoc = documentos.find(d => d.codigo === item.codigo_documento || d.nombre === item.codigo_documento);
              const tipos = getDocumentosTipos();
              const selectedTipo = tipos.find(t => t.codigo === String(item.tipo));
              
              return (
                <tr key={docIndex}>
                  <td className="py-4 px-4 pl-0 border-t">
                    <TextDisplay
                      value={selectedDoc
                        ? `${selectedDoc.codigo}${selectedDoc.nombre ? ` (${selectedDoc.nombre})` : ''}`
                        : item.codigo_documento
                      }
                    />
                  </td>
                  <td className="py-4 px-4 border-t">
                    <TextDisplay
                      value={selectedTipo
                        ? `${selectedTipo.codigo}${selectedTipo.nombre ? ` (${selectedTipo.nombre})` : ''}`
                        : item.tipo
                      }
                    />
                  </td>
                  <td className="py-4 px-4 border-t">
                    <TextDisplay value={item.numero} />
                  </td>
                  <td className="py-4 border-t">
                    <TextDisplay value={item.fecha} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
